export default __webpack_public_path__ + "static/B3_M1-ab21a4931566f0655dc71f0cfaa4ea40.png";